<template>
  <p-check
    class="pretty p-bigger p-curve p-svg p-jelly"
    color="success"
    :v-model="state"
    :checked="state"
    @change="change"
  >
    <!-- svg path -->
    <svg slot="extra" class="icon svg svg-icon" viewBox="0 0 20 20">
      <path
        d="M7.629 14.566a.644.644 0 00.912 0l8.219-8.221a.643.643 0 10-.911-.911l-7.764 7.763-3.933-3.93a.645.645 0 00-.911.911l4.388 4.388z"
        stroke="#fff"
        fill="#fff"
      />
    </svg>
    <slot></slot>
  </p-check>
</template>

<script>
export default {
  name: "Checkbox",
  props: {
    active: Boolean,
    change: Function,
  },
  data: function () {
    return {
      state: this.active,
    };
  },
};
</script>

<style lang="postcss">
.pretty {
  @apply whitespace-normal my-0;

  .state {
    @apply relative;

    .svg {
      @apply w-8 h-8;
    }

    label {
      @apply text-primary subpixel-antialiased leading-normal;
      &::before {
        @apply top-0 border-accent rounded-lg !important;
      }
    }
  }

  input:checked ~ .state.p-success label:after {
    @apply bg-accent !important;
  }
  &.p-bigger {
    .icon,
    .svg {
    }
  }
}
</style>
